// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__vO8f4","input":"styles_input__T5zR5"};